
import {mergeMap, map, takeUntil} from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter, HostListener, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { TimeSpan } from 'typescript-dotnet-es6/System/Time/TimeSpan';
import { TimeUnit } from 'typescript-dotnet-es6/System/Time/TimeUnit';

import { Observable, Subscription } from 'rxjs';

import { AddDaysToDate } from '../../../core';

interface selectableDate { date: DateTime, selected: boolean }

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, OnDestroy {
  numberOfDatesSelected: number = 0;
  numberOfDatesRemaining: number = 30;

  constructor() {
    let dateNow = this.now().date;
    let tommorrow = AddDaysToDate(dateNow, 1);
    let firstDayOfTheMonth = new DateTime(new Date(dateNow.year, dateNow.month, 1, 0, 0, 0, 0), DateTime.Kind.Utc);
    let lastDay = AddDaysToDate(tommorrow.addMonths(3), -1);
    this.startDateRange = this.now();
    this.endDateRange = this.now();
    this.setDateRange(tommorrow.toJsDate(), lastDay.toJsDate())
    this.setMonth(firstDayOfTheMonth);
  }
  ngOnInit() {
    this.setupMouseDrag();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  mouseup = new EventEmitter<MouseEvent>();
  mousedown = new EventEmitter<MouseEvent>();
  mousemove = new EventEmitter<MouseEvent>();
  mousedrag: Observable<{ start: Element, end: Element }>;
  acceptMouseMoveCounter: number;
  trackingDrag: boolean = false;
  //@HostListener('mouseup', ['$event'])
  onMouseup(event: MouseEvent) {
    if (this.trackingDrag) {
      this.mouseup.emit(event);
      this.trackingDrag = false;
      window.removeEventListener('mouseup', this.onMouseupBoundEvent, true);
      return false;
    }
    return true;
  }
  onMouseupBoundEvent = this.onMouseup.bind(this);
  @HostListener('mousedown', ['$event'])
  onMousedown(event: MouseEvent) {
    if (event.button === 2)
      return true; // prevents right click drag,
    let elem = event.target as Element;
    if(elem!=null){
      let classStr = elem.attributes['class'];
      if (classStr && classStr.value.includes("dayInAudit")) {
        window.addEventListener('mouseup', this.onMouseupBoundEvent, true);
        this.trackingDrag = true;
        this.acceptMouseMoveCounter = 0;
        this.mousedown.emit(event);
        return false; // Call preventDefault() on the event
      }
    }
    return false;//prevent text highlighting
  }

  @HostListener('mousemove', ['$event'])
  onMousemove(event: MouseEvent) {
    if (this.trackingDrag) {
      if (event.button === 2)
        return true; // prevents right click drag,
        let elem = event.target as Element;
        if(elem!=null){
          let classStr = elem.attributes['class'];
          if (classStr && classStr.value.includes("dayInAudit")) {
          if (this.acceptMouseMoveCounter > 4) {
            this.mousemove.emit(event);
          } else {
            this.acceptMouseMoveCounter++;
          }
        }
        return false; // Call preventDefault() on the event
      }
    }
    return true;
  }
  setupMouseDrag() {

    this.mousedrag = this.mousedown.asObservable().pipe(map(event => {
      return {
        start: event.target as Element,
        end: null as Element
      };
    }),
      mergeMap(
      first => this.mousemove.asObservable().pipe(map(move => ({
        start: first.start,
        end: move.target as Element
      })),
        takeUntil(this.mouseup.asObservable()),)
      ),);
    let s1 = this.mousedrag.subscribe(drag => {
      let ndx1 = parseInt(drag.start.attributes['dayIndex'].value);
      if (drag.end) {
        let ndx2 = parseInt(drag.end.attributes['dayIndex'].value);
        if (ndx1 <= ndx2)
          this.enableAuditDates(ndx1, ndx2);
        else
          this.enableAuditDates(ndx2, ndx1);
      }
    });
    this.subscriptions.push(s1);
  }

  enableAuditDates(start: number, end: number) {

    let datesSelected = 0;
    this.auditDates.forEach(d => d.selected = false);
    for (let ndx = start; ndx <= end; ndx++) {
      let m = ~~(ndx / 35);
      let w7d = ndx % 35;
      let d = this.dates[m][w7d];
      if (d.refAuditDate) {
        d.refAuditDate.selected = true;
      }
    }
    this.auditDates.forEach(d => {
      if (d.selected) {
        datesSelected++;
      }
    }
    )
    this.numberOfDatesSelected = datesSelected;
    this.numberOfDatesRemaining = 30 - this.numberOfDatesSelected;
  }

  public monthNames: string[] = [];

  firstDay: DateTime[] = [];
  monthsIndex = [0, 1, 2]
  weeksIndex = [0, 1, 2, 3, 4];
  daysIndex = [0, 1, 2, 3, 4, 5, 6];
  dayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  month: DateTime[]; //
  dates: { date: DateTime, refAuditDate?: selectableDate }[][] = [];


  now: () => DateTime = () => DateTime.now;
  subscriptions: Subscription[] = [];

  setMonth(day1: DateTime) {
    this.firstDay = [];
    this.monthNames = [];
    this.month = [];
    this.monthsIndex.forEach(m => {
      this.month.push(day1);
      this.firstDay.push(AddDaysToDate(day1, -day1.dayOfWeek));
      this.monthNames.push(day1.toJsDate().toLocaleString(undefined, { month: 'long' }))
      day1 = day1.addMonths(1);
    });
    this.dates = [];
    this.firstDay.forEach((day0, im, a) => {
      let arr = [];
      // if(this.dates.length>im){
      //   this.dates[im]=arr;
      // }else{
      this.dates.push(arr);
      // }
      for (let day = day0, i = 0; i < (7 * 5); i++ , day = AddDaysToDate(day, 1)) {
        let ref = this.findAuditDate(day);
        arr.push({ date: day, refAuditDate: ref })
      }
    });
  }

  findAuditDate(date: DateTime): selectableDate {

    if (date.toJsDate() >= this.startDateRange.toJsDate()
      && date.toJsDate() <= this.endDateRange.toJsDate()) {
      let d1 = date.toJsDate().valueOf();
      let d2 = this.startDateRange.toJsDate().valueOf();
      let msecDif = d1 - d2;
      if (msecDif >= 0) {
        let dif = new TimeSpan(msecDif, TimeUnit.Milliseconds);
        let auditDate: selectableDate = this.auditDates[Math.round(dif.days)];
        if (auditDate && Math.round(auditDate.date.timePassedSince(date).days) == 0)
          return auditDate;
      }
      let dis = this.auditDates.find(item => {
        let days = item.date.timePassedSince(date).days;
        return Math.round(days) == 0;
      });
      return dis;
    }
    return null;
  }
  startDateRange: DateTime;
  endDateRange: DateTime;
  auditDates: selectableDate[] = [];


  setDateRange(start: Date, end: Date) {
    let startDateRange = new DateTime(start, DateTime.Kind.Local);
    let endDateRange = new DateTime(end, DateTime.Kind.Local);
    let auditDates: selectableDate[] = [];

    for (var day = startDateRange; day.toJsDate() < endDateRange.toJsDate(); day = AddDaysToDate(day, 1)) {
      var init = { date: day, selected: false };

      if (day.toJsDate() >= this.startDateRange.toJsDate() && day.toJsDate() < this.endDateRange.toJsDate()) { //if in the old range copy from day to new end date
        auditDates = auditDates.concat(
          this.auditDates
            .filter(date => date.date.toJsDate() >= startDateRange.toJsDate() && date.date.toJsDate() <= endDateRange.toJsDate()));
        day = AddDaysToDate(this.endDateRange, -1);
        if (day.toJsDate() > end)
          day = endDateRange;
      } else {
        auditDates.push(init);
      }
    }

    let datesSelected = 0;
    auditDates.forEach(auditDate => {
      if (auditDate.selected)
        datesSelected++;
    });

    this.numberOfDatesSelected = datesSelected;
    this.numberOfDatesRemaining = 30 - this.numberOfDatesSelected;

    this.auditDates = auditDates;
    this.startDateRange = startDateRange;
    this.endDateRange = endDateRange;
    if (this.month && this.month.length > 0) {
      this.setMonth(this.month[0]);
    }

  }






  toggleSelect(m, w, d) {

    let day = this.dates[m][(w * 7) + d];
    let i = 0;
    if (day.refAuditDate) {
      this.toggleAuditDate(day.refAuditDate);
    }
  }

  toggleAuditDate(auditDate) {
    auditDate.selected = !auditDate.selected;
    if (auditDate.selected)
      this.numberOfDatesSelected++;
    else
      this.numberOfDatesSelected--;
    this.numberOfDatesRemaining = 30 - this.numberOfDatesSelected;
  }

  getAuditDate(m, w, d) {
    let day = this.dates[m][w * 7 + d];
    if (day.refAuditDate) {
      return day.refAuditDate;
    }
    return null;
  }

  getDayString(m: number, w: number, d: number): string {
    let date = AddDaysToDate(this.firstDay[m], (w * 7) + d);
    return date.day.toString();
  }

  getClassString(m: number, w: number, d: number): string {
    let day = this.dates[m][w * 7 + d];
    let classStr = "";
    if (day.refAuditDate) {
      classStr = "dayInAudit ";
      if (day.refAuditDate.selected) {
        classStr += "selectedDate ";
      }

    }
    if (this.daysSince(day.date, this.month[m]) >= 0 && this.daysSince(day.date, this.month[m].addMonths(1)) < 0) {
      classStr += "dayInMonth ";
    }
    return classStr;
  }

  daysSince(day: DateTime, priorDay: DateTime): number {
    return Math.round(day.timePassedSince(priorDay).days);
  }
  trackById(index, item) {
    //console.log(item);
    return item;
  }
  public loadPrevious() {
    this.setMonth(this.month[0].addMonths(-1));
  }


  loadNext() {
    this.setMonth(this.month[0].addMonths(1));

  }


  onButtonSelectDateRange(dayOfWeek) {

    this.auditDates.forEach(auditDate => {
      if (auditDate.date.dayOfWeek == dayOfWeek) {
        this.toggleAuditDate(auditDate);
      }
    });
  }

  GetCalendarSelectedDates() {
    var selectedDates = this.auditDates.filter(auditDate => auditDate.selected)
      .map(auditDate => auditDate.date);
    return selectedDates;
  }

}
